//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    trackingLogs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  watch: {},
  mounted: function mounted() {},
  methods: {}
};